<div
  class="banner-card"
  (click)="clickHandler()"
  [lazyLoad]="banner.imageURL"
  [offset]="100"
></div>
